export enum EDaysOfWeek {
  monday = 'จันทร์',
  tuesday = 'อังคาร',
  wednesday = 'พุธ',
  thursday = 'พฤหัสบดี',
  friday = 'ศุกร์',
  saturday = 'เสาร์',
  sunday = 'อาทิตย์',
}
export interface IImageEntity {
  img: string;
  title: string;
  description?: string;
  excerpt?: string;
}

export interface IImageGalleryEntity {
  img: string;
  name: string;
  description?: string;
  hot_badge_enable?: number;
}
export interface IPublishEntity {
  publish_time?: string;
  unpublish_time?: string;
}

export interface ISeoEntity {
  seoPageTitle: string;
  seoMetaDescription: string;
  seoUrl: string;
}

export interface IContenEntity {
  contentHTML?: string;
}

export interface IDataInfoEntity {
  phone: string;
  email: string;
  address: string;
  etax?: boolean;
}

export interface ILocationEntity {
  id?: string;
  lat: string;
  lng: string;
  linkLocationName?: string;
}

export interface IVedioEntity {
  link_url: string;
  isVideo: boolean;
}

export interface ISocialMediaEntity {
  icon?: string;
  lable?: string;
  url: string;
  value: string;
}

export interface IInfoDataEntity {
  icon: string;
  label?: string;
  value: string;
  workDay?: IWorkDayEntity[];
}

export interface IProductEntity {
  productId?: string;
  productImg?: string;
  productName?: string;
  productTyreBead?: string;
  productPrice: string;
  imgProductGroup?: [];
}

export interface IButtonEntity {
  label?: string;
  icon?: string;
  url?: string;
}

export interface IPageHeaderEntity {
  pageTitle: string;
  pageSubTitle?: string;
  subTitles: ISubTitlesEntity[];
}

export interface IWorkDayEntity {
  label: string;
  open: string;
  close: string;
  enable: number;
}

export interface ISubTitlesEntity {
  title?: string;
  partName: string;
  unUsePointer?: boolean;
}

export interface IImage extends IImageEntity, ISeoEntity, IContenEntity, IPublishEntity {}

export interface IImageGallery extends IImageGalleryEntity, IItemNumberEntity {}

export interface IKnowledge extends IImageEntity, IVedioEntity {}

export interface ILocation extends IImageEntity, IDataInfoEntity, ILocationEntity {}

export interface IImageList extends IImageEntity, IItemNumberEntity {}

export interface IPublish extends IImageEntity, IPublishEntity {}
export interface ILocationData extends IImageEntity, ILocationEntity {
  socialMediaGroup: ISocialMediaEntity[];
  addressDataGroup: IInfoDataEntity[];
  linkLocationLable: string;
}

export interface IProduct extends IProductEntity {
  buttonGroup?: IButtonEntity[];
}

export interface IPaging {
  cur?: number;
  per?: number;
}

export interface ISubTermsAndPolicyEntity extends IContenEntity {
  headers?: string;
  topic?: string;
  subtopic?: string;
  title?: string;
}

export interface ITermsAndPolicyEntity {
  header?: string;
  title?: string;
  subtitle?: ISubTermsAndPolicyEntity[];
}

export interface IAdvertisementEntity {
  carouselOptions: ICarouselOptionsEntity;
  carouselSlide: ICarouselSlideEntity[];
}

export interface ICarouselOptionsEntity {
  loop: boolean;
  margin: number;
  nav: boolean; // Enable navigation
  dots: boolean;
  lazyLoad: boolean;
  autoplay: boolean;
  autoplayTimeout: number;
  navText: any[];
  responsive: {
    0: {
      items: 1; // Show 1.5 items on smaller screens
    };
  };
}

export interface ICarouselSlideEntity {
  link_url: string;
  mobile_image_url: string;
  pc_image_url: string;
  position: string;
  title: string;
}

export interface IItemNumberEntity {
  id: number;
}

export interface IContacForm {
  companyName: string;
  contactInfo: IInfoDataEntity[];
}

export interface IAfterSaleService {
  groupImageContent: ITermsAndPolicyEntity;
  groupDescriptionContent: ITermsAndPolicyEntity[];
  topic: string;
}

export interface IProductCarousel {
  detail: string;
  imgFeature: string;
  title: string;
}

export interface IPostContact {
  name: string;
  surname: string;
  tel: number;
  email: string;
  message: string;
  type: number;
  channel: string;
}
export interface IPostFranchise {
  name: string;
  surname: string;
  tel: number;
  email: string;
  type: number;
  channel: string;
}

export interface IPostGalleryLikeBody {
  gallery_id: number;
  ip_address: string;
}
